import { starterDeck } from "../builder";

export const ES_RU_BASIC = starterDeck({
  id: "es-ru-basic-a1",
  name: "Испанский — основы",
  name_en: "Spanish — Basics",
  description: "Приветствия и базовая лексика для путешествия.",
  description_en: "Greetings and basic vocabulary for traveling.",
  sourceLang: "es",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["Hola", "Привет"],
    ["Buenos días", "Доброе утро"],
    ["Buenas tardes", "Добрый день"],
    ["Buenas noches", "Доброй ночи / Добрый вечер"],
    ["Adiós", "До свидания"],
    ["Hasta luego", "До встречи", "phrase"],
    ["Por favor", "Пожалуйста"],
    ["Gracias", "Спасибо"],
    ["De nada", "Не за что", "phrase"],
    ["Sí", "Да"],
    ["No", "Нет"],
    ["Perdón", "Извини / Простите"],
    ["¿Cómo estás?", "Как дела?", "phrase"],
    ["Estoy bien", "Я в порядке", "phrase"],
    ["¿Cómo te llamas?", "Как тебя зовут?", "phrase"],
    ["Me llamo…", "Меня зовут…", "phrase"],
    ["Mucho gusto", "Очень приятно", "phrase"],
    ["No entiendo", "Я не понимаю", "phrase"],
    ["¿Hablas inglés?", "Ты говоришь по-английски?", "phrase"],
    ["Ayuda", "Помощь"],
  ],
});

export const ES_RU_FOOD = starterDeck({
  id: "es-ru-food-a1",
  name: "Испанский — еда",
  name_en: "Spanish — Food",
  description: "Еда и напитки по-испански.",
  description_en: "Food and drinks in Spanish.",
  sourceLang: "es",
  targetLang: "ru",
  topic: "food",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["pan", "хлеб"],
    ["agua", "вода"],
    ["leche", "молоко"],
    ["café", "кофе"],
    ["té", "чай"],
    ["vino", "вино"],
    ["cerveza", "пиво"],
    ["queso", "сыр"],
    ["jamón", "ветчина"],
    ["pollo", "курица"],
    ["pescado", "рыба"],
    ["arroz", "рис"],
    ["huevo", "яйцо"],
    ["fruta", "фрукт"],
    ["manzana", "яблоко"],
    ["naranja", "апельсин"],
    ["plátano", "банан"],
    ["tomate", "помидор"],
    ["sopa", "суп"],
    ["postre", "десерт"],
  ],
});

export const ES_EN_TRAVEL = starterDeck({
  id: "es-en-travel-a2",
  name: "Spanish travel basics (ES→EN)",
  name_ru: "Испанский для путешествий (ES→EN)",
  description: "Common phrases for Spanish-speaking countries.",
  description_ru: "Частые фразы для испаноязычных стран.",
  sourceLang: "es",
  targetLang: "en",
  topic: "travel",
  ageGroup: "adult",
  level: "A2",
  cards: [
    ["aeropuerto", "airport"],
    ["billete", "ticket"],
    ["maleta", "suitcase"],
    ["pasaporte", "passport"],
    ["habitación", "room"],
    ["llave", "key"],
    ["estación", "station"],
    ["autobús", "bus"],
    ["tren", "train"],
    ["coche", "car"],
    ["calle", "street"],
    ["plaza", "square"],
    ["mapa", "map"],
    ["¿Dónde está…?", "Where is…?", "phrase"],
    ["¿Cuánto cuesta?", "How much does it cost?", "phrase"],
    ["a la derecha", "to the right", "phrase"],
    ["a la izquierda", "to the left", "phrase"],
    ["recto", "straight"],
  ],
});
